
import { auth } from './firebase'; // Firebase auth singleton

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// ===== Public API Client (for unauthenticated requests) =====
const publicFetch = async (url, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  const fetchUrl = API_BASE_URL ? `${API_BASE_URL}${url}` : url;
  const response = await fetch(fetchUrl, { ...options, headers });
  return response;
};

export const publicApiClient = {
  get: (url, options) => publicFetch(url, { ...options, method: 'GET' }),
  post: (url, body, options) => publicFetch(url, { ...options, method: 'POST', body: JSON.stringify(body) }),
  put: (url, body, options) => publicFetch(url, { ...options, method: 'PUT', body: JSON.stringify(body) }),
  delete: (url, options) => publicFetch(url, { ...options, method: 'DELETE' }),
};

// ===== Authenticated API Client (for requests requiring user auth) =====
const getAuthToken = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe(); // Stop listening after the first state change
      if (user) {
        user.getIdToken().then(token => resolve(token), error => reject(error));
      } else {
        resolve(null); // No user, resolve with null
      }
    }, error => {
      reject(error); // Handle listener errors
    });
  });
};

const authorizedFetch = async (url, options = {}) => {
  const token = await getAuthToken();

  if (!token) {
    const errorResponse = new Response(JSON.stringify({ error: 'Unauthorized: No token provided' }), {
      status: 401,
      headers: { 'Content-Type': 'application/json' }
    });
    return Promise.reject(errorResponse);
  }

  const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const fetchUrl = API_BASE_URL ? `${API_BASE_URL}${url}` : url;
  const response = await fetch(fetchUrl, { ...options, headers });

  return response;
};

export const apiClient = {
  get: (url, options) => authorizedFetch(url, { ...options, method: 'GET' }),
  post: (url, body, options) => authorizedFetch(url, { ...options, method: 'POST', body: JSON.stringify(body) }),
  put: (url, body, options) => authorizedFetch(url, { ...options, method: 'PUT', body: JSON.stringify(body) }),
  delete: (url, options) => authorizedFetch(url, { ...options, method: 'DELETE' }),
};
